import { PageBreadcrumbContainer } from "lib/page-breadcrumb-container"
import { HelpTag } from "routes/help/helpTag"
import { Stack } from "@mui/material"
import { RegisterList } from "routes/asset-register/register-list"
import { Feature } from "lib/@components/feature"
import { FEATURE_FLAG_ASSET_MAPPING } from "routes/asset-register/feature-flag-asset-mapping"
import { HELPTAG_ASSET_REGISTERS } from "routes/help/help-tag-constants"
import { AssetRegistersTop } from "slot-definitions"
import { RegisterToolbar } from "./register-toolbar"

export function AssetRegisters() {
    AssetRegistersTop.usePlug(<RegisterToolbar />)

    return (
        <PageBreadcrumbContainer title="Asset Registers" sx={{ height: 1 }}>
            <HelpTag tags={[HELPTAG_ASSET_REGISTERS]} />
            <Stack spacing={2} sx={{ mt: 2, flex: 1, minHeight: 0, overflowX: "hidden", overflowY: "auto" }}>
                <Feature feature={FEATURE_FLAG_ASSET_MAPPING}>
                    <RegisterList $lazy />
                </Feature>
            </Stack>
        </PageBreadcrumbContainer>
    )
}
